// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__9iq1E","rootSuccess":"CompleteLink_rootSuccess__1wykg","rootFailure":"CompleteLink_rootFailure__3K7IU","isDisabled":"CompleteLink_isDisabled__2bB1Q"};